// extracted by mini-css-extract-plugin
export var collapsedSummary = "_oz-0";